import store from "@/store/index.js";
import userMixin from "./userMixin";
import axios from "axios";

export default {
  data() {
    return {
      activePlan: null, // Initialize activePlan as null
    };
  },
  methods: {
    async userplan_status() {
      try {
        const userId = sessionStorage.getItem("user_id");
        const response = await axios.post(
          `${process.env.VUE_APP_API_ROOT_URL}/api/getactiveplan`,
          {
            userId,
          }
        );

        if (response.status === 200) {
          this.activePlan = response.data.activePlan;

          // if (this.activePlan) {
          //   // User has an active plan, you can access this.activePlan here
          //   console.log("Active Plan:", this.activePlan);
          // } else {
          //   // User does not have an active plan
          //   console.log("User does not have an active plan");
          // }
        }
      } catch (error) {
        console.error("Error fetching active plan:", error);
      }
      // return activePlan;
    },
    userplan_plan_amount: function () {
      let amount = null;
      if (this.activePlan) {
        // Use this.activePlan to determine the amount
        if (this.activePlan.name === "Khonsu Unlimited") {
          console.log("Khonsu Unlimited mate");
          amount = "£50";
        }
        if (this.activePlan.name === "Khonsu Single Session") {
          console.log("Khonsu single mate");

          amount = "£5";
        }
        if (this.activePlan.name === "Khonsu Light") {
          console.log("Khonsu light mate");

          amount = "£10";
        }
      }

      return amount;
    },
    userplan_name: function () {
      return sessionStorage.getItem("_khonsu_user_plan_name");
    },
    //  SO THIS WOULD PROBABLY GO OFF CREDITS
    userplan_search_count: function () {
      return sessionStorage.getItem("_khonsu_user_plan_search_count");
    },
    userplan_expiry_date: function () {
      return sessionStorage.getItem("_khonsu_user_plan_expiry_date");
    },

    userplan_deactivate: function (planName, userid) {
      let data = {
        planName: planName,
        userid: userid,
      };
      let deactivate = store.dispatch("Plan/deactivateplan", data);
      if (!deactivate) {
        console.log("eror occured");
      }
      if (deactivate) {
        userMixin.methods.setUserPlanStatus("inactive");
        userMixin.methods.setUserPlanName("");
        userMixin.methods.setUserPlanSearchCount("");
        userMixin.methods.setUserPlanExpiry_date("");
      }
    },
  },
};
